import React, { Component } from 'react';
import '../App.css';
import CalendarAPI from '../Codes/CalendarAPI';
import googleIcon from '../Img/google-favicon-512.png';
import Img from '../Img/LogImg.png';

class SigninToCalendar extends Component {
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return( 
        <div>
            <header>
                <div className="row-main">
                    <div className="col-4">
                    <div className="sponser-logo">
                        <label className="sponser-logo">כרמל 6000</label><br/>
                        <label className="sponser-logo">בחסות רשת אמית</label>
                    </div>
                    </div>
                    <div className="col-4 flex-bottom">
                        <h1>לוח 6000</h1>
                    </div>
                    <div className="col-4"></div>
                </div>
            </header>
            <div>
                <img src={Img} alt="calendar image" className="big-img"></img>
                <h4 className="desc-login">מוסיפים ליומן</h4>
                <h4 className="desc-login">גוגל אירוע בתאריך עברי</h4>
                <h4 className="desc-login">ומקבלים תזכורת - בכל שנה!</h4>
                <div>
                    <div onClick={CalendarAPI.signIn} className="btn login-button border">
                        <div className="col-sm-3 div-right"><img className="icon-img" alt="google icon" src={googleIcon}></img></div>
                        <div className="col-sm-9 div-left"><label>כניסה ליומן הגוגל שלך</label></div>
                    </div>
                </div>
            </div>
            
        </div>
        );
    }
}
export default SigninToCalendar;





// WEBPACK FOOTER //
// ./src/components/SigninToCalendar.js